import { render, staticRenderFns } from "./ProductSearchBox.vue?vue&type=template&id=e57c6438&scoped=true&"
import script from "./ProductSearchBox.vue?vue&type=script&lang=ts&"
export * from "./ProductSearchBox.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearchBox.vue?vue&type=style&index=0&id=e57c6438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57c6438",
  null
  
)

export default component.exports